"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _SimpleDate = require("../../core/SimpleDate");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _calendarUtils = require("./calendarUtils");

var AbstractCalendar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AbstractCalendar, _Component);

  function AbstractCalendar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AbstractCalendar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AbstractCalendar).call(this, props));

    _this.handleInputChange = function (evt) {
      var _this$props = _this.props,
          format = _this$props.format,
          locale = _this$props.locale,
          onChange = _this$props.onChange,
          value = _this$props.value;

      _this.setState({
        inputValue: evt.target.value
      }); // Update date value as the user types


      var userInput = evt.target.value.trim();

      if (userInput === '') {
        onChange((0, _SyntheticEvent.default)(null));
      } else {
        var userInputDate = (0, _SimpleDate.fromString)(userInput, format, locale);

        if (userInputDate !== null && !(0, _SimpleDate.equals)(userInputDate, value)) {
          _this.updateDate(userInputDate);
        }
      }
    };

    _this.handleKeyDown = function (evt) {
      var _this$props2 = _this.props,
          onOpenChange = _this$props2.onOpenChange,
          open = _this$props2.open,
          today = _this$props2.today,
          value = _this$props2.value;
      var key = evt.key;
      clearTimeout(_this._keyUpTimeout);
      _this._pressedKey = key; // The "keyboard cursor" is implicitly on the current selection, or today's date if clear.

      var computedCurrentDate = (0, _SimpleDate.isValid)(value) ? value : today;

      if (key === 'ArrowUp') {
        evt.preventDefault();
        var newValue = (0, _SimpleDate.nextDay)(computedCurrentDate);

        _this.updateDate(newValue);
      } else if (key === 'ArrowDown') {
        evt.preventDefault();

        var _newValue = (0, _SimpleDate.prevDay)(computedCurrentDate);

        _this.updateDate(_newValue);
      } else if (key === 'Escape') {
        if (!open || !onOpenChange) return;
        evt.preventDefault();
        onOpenChange((0, _SyntheticEvent.default)(false));
      }
    };

    _this.handleKeyUp = function () {
      // The delay here should ensure that onKeyUp resolves after onChange, even under IE11 (#7331).
      clearTimeout(_this._keyUpTimeout);
      _this._keyUpTimeout = setTimeout(function () {
        _this._pressedKey = null;
      }, 0);
    };

    _this.handleBlur = function () {
      var _this$props3 = _this.props,
          format = _this$props3.format,
          onFocusedValueChange = _this$props3.onFocusedValueChange,
          value = _this$props3.value;

      _this.updateInput(value, format);

      onFocusedValueChange((0, _SyntheticEvent.default)(null));
    };

    _this.state = {
      inputValue: (0, _SimpleDate.toFormattedString)(props.value, props.format, props.locale)
    };
    _this._keyUpTimeout = 0;
    _this._pressedKey = null;
    return _this;
  }

  (0, _createClass2.default)(AbstractCalendar, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props4 = this.props,
          calendarPage = _this$props4.calendarPage,
          onCalendarPageChange = _this$props4.onCalendarPageChange,
          onOpenChange = _this$props4.onOpenChange,
          open = _this$props4.open,
          value = _this$props4.value;

      if (!(0, _SimpleDate.equals)(value, nextProps.value)) {
        // Flip to the calendar page that includes the selected date
        var newCalendarPage = (0, _calendarUtils.getPageFromDate)(nextProps.value);

        if (!(0, _SimpleDate.equals)(newCalendarPage, calendarPage)) {
          onCalendarPageChange((0, _SyntheticEvent.default)(newCalendarPage));
        } // `pressedKey` tells us whether this change was caused by the mouse or the keyboard


        var shouldClosePicker = this._pressedKey === null;
        var shouldUpdateInput = this._pressedKey === null || this._pressedKey === 'ArrowUp' || this._pressedKey === 'ArrowDown';

        if (shouldClosePicker && open) {
          onOpenChange((0, _SyntheticEvent.default)(false));
        }

        if (shouldUpdateInput) {
          this.updateInput(nextProps.value, nextProps.format);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this._keyUpTimeout);
    }
  }, {
    key: "updateInput",
    value: function updateInput(value, format) {
      var locale = this.props.locale;
      var inputValue = this.state.inputValue;
      var formattedDate = (0, _SimpleDate.toFormattedString)(value, format, locale);

      if (formattedDate !== inputValue) {
        this.setState({
          inputValue: formattedDate
        });
      }
    }
  }, {
    key: "updateDate",
    value: function updateDate(newValue) {
      var _this$props5 = this.props,
          calendarPage = _this$props5.calendarPage,
          disabledValues = _this$props5.disabledValues,
          max = _this$props5.max,
          maxValue = _this$props5.maxValue,
          min = _this$props5.min,
          minValue = _this$props5.minValue,
          onCalendarPageChange = _this$props5.onCalendarPageChange,
          onChange = _this$props5.onChange,
          onFocusedValueChange = _this$props5.onFocusedValueChange,
          onOpenChange = _this$props5.onOpenChange;

      if (!calendarPage || newValue.month !== calendarPage.month) {
        onCalendarPageChange((0, _SyntheticEvent.default)({
          year: newValue.year,
          month: newValue.month
        }));
      }

      if (!(0, _SimpleDate.equals)(newValue, (0, _SimpleDate.getBoundedDate)(newValue, min || minValue, max || maxValue)) || disabledValues && disabledValues.some(function (disabledValue) {
        return (0, _SimpleDate.equals)(newValue, disabledValue);
      })) {
        // Show tooltip on disabled date
        onFocusedValueChange((0, _SyntheticEvent.default)(newValue));
        onOpenChange((0, _SyntheticEvent.default)(true));
        return;
      }

      onFocusedValueChange((0, _SyntheticEvent.default)(null));
      onChange((0, _SyntheticEvent.default)(newValue));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var inputValue = this.state.inputValue;
      return children({
        onBlur: this.handleBlur,
        onInputChange: this.handleInputChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        inputValue: inputValue
      });
    }
  }]);
  return AbstractCalendar;
}(_react.Component);

if (process.env.NODE_ENV !== 'production') {
  AbstractCalendar.propTypes = {
    calendarPage: _propTypes.default.shape({
      year: _propTypes.default.number.isRequired,
      month: _propTypes.default.number.isRequired
    }),
    children: _propTypes.default.func.isRequired,
    disabledValues: _propTypes.default.arrayOf(_SimpleDateTypes.SimpleDateType),
    format: _propTypes.default.oneOf(['L', 'YYYY-MM-DD']).isRequired,
    locale: _propTypes.default.string,
    max: _SimpleDateTypes.SimpleDateType,
    maxValue: _SimpleDateTypes.SimpleDateType,
    min: _SimpleDateTypes.SimpleDateType,
    minValue: _SimpleDateTypes.SimpleDateType,
    onCalendarPageChange: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired,
    onFocusedValueChange: _propTypes.default.func.isRequired,
    onOpenChange: _propTypes.default.func,
    open: _propTypes.default.bool,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    value: _SimpleDateTypes.SimpleDateType
  };
}

AbstractCalendar.defaultProps = {
  format: 'L'
};
var _default = AbstractCalendar;
exports.default = _default;
module.exports = exports.default;